import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Input,
  Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { Link, useParams } from "react-router-dom";
import { setBreadcrumbItems } from "../../store/actions";
import { toast } from "react-toastify";

const ViewDetails = (props) => {
  const { id } = useParams();
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Business Request Details", link: "#" },
  ];
  const [isLoading, setLoading] = useState(false);
  const detail = {};
  const [details, setAllDetails] = useState(detail);
  useEffect(() => {
    onGetBusinessDetails(id);
    props.setBreadcrumbItems("Business Request Details", breadcrumbItems);
  }, []);
  function onGetBusinessDetails(id) {
    try {
      const urlPath = `/business-request-details/${id}`;
      fetch(url.GBN_URL + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          if (responseData.status) {
            const responseDetails = responseData.result;
            const responseUserDetails = responseData.result.userId;
            setAllDetails([
              {
                service:
                  Array.isArray(responseDetails?.services) &&
                  responseDetails.services.filter((s) => s.trim() !== "")
                    .length > 0
                    ? responseDetails.services
                        .filter((s) => s.trim() !== "")
                        .join(", ")
                    : "Not Available",
                business_name: responseDetails.businessName,
                business_address:
                  responseDetails.city +
                  "," +
                  responseDetails.state +
                  "," +
                  responseDetails.country,
                business_domain: responseDetails.domain,
                site_url: responseDetails.website
                  ? responseDetails.website
                  : "Not Available",
                businessType: responseDetails.businessType
                  ? responseDetails.businessType
                  : "Not Available",
                business_request_status: responseDetails.requestStatus,
              },
              {
                full_name:
                  responseUserDetails.firstName +
                  "," +
                  responseUserDetails.lastName,
                mobileNo: responseUserDetails.mobileNo,
                email: responseUserDetails.email
                  ? responseUserDetails.email
                  : "Not Available",
                gender: responseUserDetails.gender,
                full_address:
                  responseUserDetails.city +
                  "," +
                  responseUserDetails.state +
                  "," +
                  responseUserDetails.country,
              },
            ]);
          }
        })
        .finally((error) => {
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      return;
    }
  }
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <>
          <div className="container py-4" style={{ maxWidth: "100%" }}>
            <Row className="justify-content-center">
              <div className="col-lg-12">
                <Card className="border-0 rounded-3">
                  <CardBody>
                    <h3 className="mb-4 text-left text-primary fw-bold">
                      User Details
                    </h3>

                    <table className="table table-bordered table-hover align-middle">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Name</th>
                          <td>{details[1]?.full_name}</td>
                        </tr>
                        <tr>
                          <th>Email</th>
                          <td>{details[1]?.email}</td>
                        </tr>
                        <tr>
                          <th>Phone</th>
                          <td>{details[1]?.mobileNo}</td>
                        </tr>
                        <tr>
                          <th>Address</th>
                          <td>{details[1]?.full_address}</td>
                        </tr>
                        <tr>
                          <th>Status</th>
                          <td>
                            {details[1]?.status ? (
                              <>
                                <span className="badge bg-success px-3 py-2">
                                  Active
                                </span>
                              </>
                            ) : (
                              <>
                                <span className="badge bg-danger px-3 py-2">
                                  In Active
                                </span>
                              </>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
                <Card className="border-0 rounded-3">
                  <CardBody>
                    <h3 className="mb-4 text-left text-primary fw-bold">
                      Business Details
                    </h3>
                    <table className="table table-bordered table-hover align-middle">
                      <tbody>
                        <tr>
                          <th>Business name</th>
                          <td>{details[0]?.business_name}</td>
                        </tr>
                        <tr>
                          <th>Domain</th>
                          <td>{details[0]?.business_domain}</td>
                        </tr>
                        <tr>
                          <th>Full Address</th>
                          <td>{details[0]?.business_address}</td>
                        </tr>
                        <tr>
                          <th>Site URL</th>
                          <td>
                            <a
                              href={
                                details[0]?.site_url.startsWith("http")
                                  ? details[0]?.site_url
                                  : `https://${details[0]?.site_url}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-decoration-none text-primary"
                            >
                              {details[0]?.site_url}
                              <i className="fas fa-external-link-alt p-1"></i>
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <th>Business Type</th>
                          <td>{details[0]?.businessType}</td>
                        </tr>
                        <tr>
                          <th>Business Request Status</th>
                          <td>
                            <span
                              className={`badge px-3 py-2 ${
                                details[0]?.business_request_status ===
                                "Approved"
                                  ? "bg-success"
                                  : details[0]?.business_request_status ===
                                      "Rejected"
                                    ? "bg-danger"
                                    : "bg-warning"
                              }`}
                            >
                              {details[0]?.business_request_status || "Pending"}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th style={{ width: "30%" }}>Services</th>
                          <td>{details[0]?.service}</td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                  <div className="d-flex justify-content-center mb-5">
                    <Link
                      to={"/business-approval"}
                      className="btn btn-outline-primary me-2"
                    >
                      <i className="fas fa-arrow-left me-1"></i>Back
                    </Link>
                  </div>
                </Card>
              </div>
            </Row>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(ViewDetails);
